import React from 'react'


class ConfirmEmail extends React.Component {


    render() {

        return (
            <div className="blank">
                <h1 style={{'marginLeft': "70px", 'marginTop': "70px"}}> {(this.props.activationCheck) ? "Email Activation Page" : "User Successfully Activated. Please Login to Continue"} </h1>
            </div>
        )
    }

}

export default ConfirmEmail